<template>
  <div class="live-resume">
    <div class="row">
      <div class="col-12">
        <div v-if="allowedToSend" class="card bg-white">
          <template v-if="selectedWhatsappTemplate">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <div class="chat-template-wrapper">
                    <TemplatePreview :template="selectedWhatsappTemplate"></TemplatePreview>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="d-flex justify-content-between">
                <div>
                  <ButtonComponent variant="tertiary" @click="openWhatsappTemplates">
                <span class="material-icons-outlined text-success">
                  lightbulb
                </span>
                    Alterar Template
                  </ButtonComponent>
                  <div class="vr"></div>
                  <ButtonComponent
                    v-if="selectedWhatsappTemplate.header && selectedWhatsappTemplate.header.type !== 'TEXT'"
                    variant="secondary" class="m-r-20" @click="changeImage">
                  <span class="material-icons-outlined">
                    image
                  </span>
                    Alterar Cabeçalho
                  </ButtonComponent>
                  <ButtonInputComponent
                    v-for="(variable, i) in selectedWhatsappTemplate.params"
                    :key="i"
                    class="param-button m-r-20"
                    variant="secondary"
                    v-model="selectedWhatsappTemplate.params[i]"
                  >
                    <template #prepend>
                      <span class="material-icons-outlined">
                        data_object
                      </span>
                    </template>
                    Adicionar parâmetro {{ i + 1 }}
                  </ButtonInputComponent>

                </div>
                <div>
                  <ButtonComponent variant="tertiary" @click="sendMessage">
                    <span class="material-icons-outlined">
                      send
                    </span>
                  </ButtonComponent>
                </div>
              </div>
            </div>
          </template>
          <div v-if="isSending" class="loading text-center text-primary my-2">
              <span aria-hidden="true" class="align-middle spinner-border">
              </span>
          </div>
        </div>
        <div v-else-if="this.$parent.$parent.currentRoom.channel === 'whatsapp-web'" class="d-flex justify-content-end">
          <div class="alert alert-danger alert-error">Canal inativo</div>
          <router-link to="/channels" class="btn-enable-channel">Ativar canal</router-link>
        </div>
        <div v-else-if="!isReopening" class="d-flex justify-content-end">
          <ButtonComponent @click="startRoom">Iniciar Conversa</ButtonComponent>
        </div>
        <div v-else class="channels justify-content-center bd-highlight mb-3">
          <!--<li class="d-inline-block">
            <a href="javascript:void(0)" class="d-block" @click="sendMessage('SmsSend')">
              <i>
                <svg id="SMS" xmlns="http://www.w3.org/2000/svg" width="31.34" height="29.7"
                     viewBox="0 0 19 18.005">
                  <path id="sms_FILL0_wght400_GRAD0_opsz48"
                        d="M4,21.29V5.425a1.38,1.38,0,0,1,.427-.986,1.35,1.35,0,0,1,1-.439h16.15a1.363,1.363,0,0,1,.986.439A1.363,1.363,0,0,1,23,5.425v12.35A1.507,1.507,0,0,1,21.575,19.2H7.8L5.211,21.789a.659.659,0,0,1-.772.154A.651.651,0,0,1,4,21.29Zm1.425-1.734,1.781-1.781H21.575V5.425H5.425Zm0-14.131h0v12.35h0V5.425Z"
                        transform="translate(-4 -4)"></path>
                  <path id="Path_1243" data-name="Path 1243"
                        d="M.287-.161V-1.1a1.8,1.8,0,0,0,.554.321,1.78,1.78,0,0,0,.6.107A1.338,1.338,0,0,0,1.756-.7a.731.731,0,0,0,.223-.089.39.39,0,0,0,.133-.135A.336.336,0,0,0,2.156-1.1a.364.364,0,0,0-.07-.22.757.757,0,0,0-.192-.179,2.005,2.005,0,0,0-.289-.158q-.167-.076-.36-.155a1.839,1.839,0,0,1-.734-.5A1.094,1.094,0,0,1,.27-3.023,1.139,1.139,0,0,1,.4-3.587,1.12,1.12,0,0,1,.76-3.976,1.609,1.609,0,0,1,1.286-4.2a2.7,2.7,0,0,1,.633-.072,3.806,3.806,0,0,1,.582.04,2.287,2.287,0,0,1,.467.122v.876a1.413,1.413,0,0,0-.23-.129,1.822,1.822,0,0,0-.256-.092,1.955,1.955,0,0,0-.262-.054,1.856,1.856,0,0,0-.248-.018,1.291,1.291,0,0,0-.293.031.751.751,0,0,0-.223.086.43.43,0,0,0-.141.133.316.316,0,0,0-.05.174.333.333,0,0,0,.056.189.639.639,0,0,0,.158.158,1.679,1.679,0,0,0,.249.146q.146.072.331.148a3.689,3.689,0,0,1,.453.224,1.609,1.609,0,0,1,.344.268,1.044,1.044,0,0,1,.22.341,1.206,1.206,0,0,1,.076.447,1.2,1.2,0,0,1-.133.59A1.082,1.082,0,0,1,2.657-.2a1.569,1.569,0,0,1-.532.212,3.073,3.073,0,0,1-.64.064A3.559,3.559,0,0,1,.828.015,1.985,1.985,0,0,1,.287-.161ZM8.631,0H7.7V-2.514q0-.407.035-.9H7.708a4.426,4.426,0,0,1-.132.557L6.592,0H5.818l-1-2.827a5.5,5.5,0,0,1-.132-.586H4.658q.038.621.038,1.09V0H3.844V-4.2H5.229l.858,2.49a3.506,3.506,0,0,1,.149.6h.018a6.047,6.047,0,0,1,.167-.606L7.28-4.2H8.631Zm.762-.161V-1.1a1.8,1.8,0,0,0,.554.321,1.78,1.78,0,0,0,.6.107A1.338,1.338,0,0,0,10.862-.7a.731.731,0,0,0,.223-.089.39.39,0,0,0,.133-.135.336.336,0,0,0,.044-.168.364.364,0,0,0-.07-.22A.757.757,0,0,0,11-1.494a2.005,2.005,0,0,0-.289-.158q-.167-.076-.36-.155a1.839,1.839,0,0,1-.734-.5,1.094,1.094,0,0,1-.242-.715,1.139,1.139,0,0,1,.132-.564,1.12,1.12,0,0,1,.359-.388,1.609,1.609,0,0,1,.526-.224,2.7,2.7,0,0,1,.633-.072,3.806,3.806,0,0,1,.582.04,2.287,2.287,0,0,1,.467.122v.876a1.413,1.413,0,0,0-.23-.129,1.822,1.822,0,0,0-.256-.092,1.955,1.955,0,0,0-.262-.054,1.856,1.856,0,0,0-.248-.018,1.291,1.291,0,0,0-.293.031.751.751,0,0,0-.223.086.43.43,0,0,0-.141.133.316.316,0,0,0-.05.174.333.333,0,0,0,.056.189.639.639,0,0,0,.158.158,1.679,1.679,0,0,0,.249.146q.146.072.331.148a3.689,3.689,0,0,1,.453.224,1.609,1.609,0,0,1,.344.268,1.044,1.044,0,0,1,.22.341,1.206,1.206,0,0,1,.076.447,1.2,1.2,0,0,1-.133.59,1.082,1.082,0,0,1-.362.387,1.569,1.569,0,0,1-.532.212,3.073,3.073,0,0,1-.64.064A3.559,3.559,0,0,1,9.933.015,1.985,1.985,0,0,1,9.393-.161Z"
                        transform="translate(3 9)"></path>
                </svg>
              </i>
            </a>
          </li>-->
          <li class="d-inline-block">
            <a href="javascript:void(0)" class="d-block" @click="openWhatsappTemplates">
              <i class="icon-font fab fa-whatsapp"></i>
            </a>
          </li>
        </div>
      </div>
    </div>
    <SidebarComponent ref="whatsapp-templates" title="Selecionar Template">
      <WhatsappTemplateSelectComponent ref="whatsapp-template-select"
                                       @changeNumber="changeSender"></WhatsappTemplateSelectComponent>
      <template #footer>
        <div class="d-flex align-items-center px-3 py-2">
          <ButtonComponent variant="secondary" class="mr-auto"
                           @click="$refs['whatsapp-templates'].toggle()">Cancelar
          </ButtonComponent>
          <ButtonComponent @click="selectWhatsappTemplate">Confirmar</ButtonComponent>
        </div>
      </template>
    </SidebarComponent>
    <template v-if="selectedWhatsappTemplate">
      <FileUploadComponent v-if="selectedWhatsappTemplate.header" ref="import-media"
                           @import="changeMedia"
                           :format="selectedWhatsappTemplate.header.type"></FileUploadComponent>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import TemplatePreview from '@/components/whatsappj/TemplatePreview.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import WhatsappTemplateSelectComponent from '@/components/whatsappj/TemplateSelectComponent.vue';
import FileUploadComponent from '@/components/form/FileUploadComponent.vue';
import ButtonInputComponent from '@/components/form/ButtonInputComponent.vue';
import Vue from 'vue';

export default {
  name: 'ChatInputComponent',
  components: {
    FileUploadComponent,
    WhatsappTemplateSelectComponent,
    SidebarComponent,
    TemplatePreview,
    ButtonComponent,
    ButtonInputComponent,
  },
  props: {
    template: {
      type: Object,
    },
    recipient: {
      type: String,
    },
    senderNumber: {
      type: String,
    },
    room: {
      type: Object,
    },
    currentChannel: {
      type: String,
    },
  },
  data() {
    return {
      isSessionActive: false,
      isReopening: false,
      isSending: false,
      selectedWhatsappTemplate: this.template,
      sender: this.senderNumber,
    };
  },
  computed: {
    allowedToSend() {
      return this.isSessionActive || this.selectedWhatsappTemplate;
    },
  },
  watch: {
    template(val) {
      this.selectedWhatsappTemplate = val;
    },
    senderNumber(val) {
      this.sender = val;
    },
  },
  methods: {
    relativeDate(date) {
      moment.locale('pt_BR');
      return moment(date).fromNow();
    },
    isOutgoing(message) {
      return ['AGENT', 'BOT'].includes(message.type_user);
    },
    startRoom() {
      this.isReopening = true;
    },
    openWhatsappTemplates() {
      this.$refs['whatsapp-templates'].show();
    },
    selectWhatsappTemplate(template) {
      if (this.$refs['whatsapp-template-select'].selectedTemplate) {
        this.selectedWhatsappTemplate = this.$refs['whatsapp-template-select'].selectedTemplate;

        const variables = this.selectedWhatsappTemplate.body.text.match(/{{[0-9]}}/g);
        if (variables) {
          this.selectedWhatsappTemplate.params = Array(this.selectedWhatsappTemplate.body.text.match(/{{[0-9]}}/g).length);
        }
        this.$refs['whatsapp-templates'].hide();
      } else {
        this.$toast.show({
          title: 'Erro',
          content: 'É necessário adicionar um template',
          type: 'danger',
        });
      }
    },
    changeImage() {
      this.$refs['import-media'].open();
    },
    changeMedia(mediaUrl) {
      this.selectedWhatsappTemplate.header.example_parameter = mediaUrl;
    },
    changeSender(sender) {
      this.sender = sender;
    },
    sendMessage() {
      this.isSending = true;
      this.$store.dispatch('storeResumeMessage', {
        channel: 'whatsapp-java',
        agent_id: this.$live.myUserId,
        sender: this.sender,
        message: this.selectedWhatsappTemplate,
        phone: this.recipient,
      }).then(
        (result) => {
          this.$live.markAsSolved(this.room);
          if (this.room.status !== 'OPEN') {
            this.$parent.$parent.currentRoom = null;
            this.$parent.$parent.tabHistoryIndex = 0;
          } else {
            this.selectedWhatsappTemplate = null;
          }
          this.$toast.show({
            title: 'Sucesso',
            content: 'Sala reaberta, aguarde o cliente responder para prosseguir com o atendimento.',
            type: 'success',
          });
        },
      ).catch(
        () => {
          this.$toast.show({
            title: 'Error',
            content: 'Falha ao reabrir a sala, entre em contato com o suporte.',
            type: 'danger',
          });
        },
      ).finally(() => {
        this.isSending = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: 0px 26px;
  margin-bottom: 0;

  .card-body {
    padding-left: 0;
    padding-right: 0;

    .chat-template-wrapper {
      border: 1px solid #E4E7EC;
      max-height: 188px;
      overflow-y: auto;
    }
  }

  .card-footer {
    border-top: 2px solid #E4E7EC;
    padding-left: 0;
    padding-right: 0;

    .btn.tertiary {
      padding-left: 0;
      padding-right: 0;
    }

    .vr {
      display: inline;
      border: 1px solid #E4E7EC;
      margin: 0 20px;
    }
  }
}

.channels {
  gap: 27px;
  display: flex;

  &.justify-content-center {
    text-align: center;
  }

  .d-inline-block {
    box-shadow: 0px 3px 36px 6px #6B23DC29;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    padding: 7px;
    text-align: center;

    i {
      font-size: 34px;
      line-height: 1;
      color: #667085;

      svg {
        fill: #667085;
      }
    }
  }
}

.loading {
  position: absolute;
  background: rgba(255, 255, 255, 0.4);
  width: 100%;
  height: 100%;
}
.alert-error {
  width: 100%;
  margin-right: 10px;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.btn-enable-channel {
    background-color: var(--clr-yup-purple) !important;
    border-color: var(--clr-yup-purple) !important;
    color: #fff !important;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    font-weight: 400;
}

.btn-enable-channel:focus {
    background-color: #0E1421 !important;
    border-color: #0E1421 !important;
    color: rgba(255, 255, 255, 0.85) !important;
}
.btn-enable-channel {
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    user-select: none;
    border: 1px solid transparent;
    padding: 8px 20px;
    font-size: .875rem;
    border-radius: .25rem;
    transition: all .2s ease;
    height: 38px;
    vertical-align: middle;
    font-weight: 300;
    cursor: pointer;
}
.btn-enable-channel{
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.btn-enable-channel {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    height: 46px;
    padding-top: 10px;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
</style>
